// The user information editor functions
var TECL_TenderUserInformationEditor = {

  // Initialise the page
  Initialise: function () {
    TECL_TenderGeneral.InitialiseStickySidebar();
  },

  // Clear all validation error text
  ClearValidationErrors: function () {
    $("#errUserDetailsOrganisationNoSearchEntries").addClass("hidden");
    $("#errUserDetailsFirstName").addClass("hidden");
    $("#errUserDetailsLastName").addClass("hidden");
    $("#errUserDetailsOrganisation").addClass("hidden");
    $("#errUserDetailsPosition").addClass("hidden");
    $("#errUserDetailsEmailAddress").addClass("hidden");
    $("#errUserDetailsUsedEmailAddress").addClass("hidden");
    $("#errUserDetailsConfirmEmailAddress").addClass("hidden");
    $("#errUserDetailsPassword").addClass("hidden");
    $("#errUserDetailsConfirmPassword").addClass("hidden");
    $("#errLoginEmailAddress").addClass("hidden");
    $("#errLoginPassword").addClass("hidden");
    $("#errLoginFail").addClass("hidden");
    $("#errUserDetailsEmailAddress").addClass("hidden");
    $("#errUserDetailsUsedEmailAddress").addClass("hidden");
    $("#errUserDetailsConfirmEmailAddress").addClass("hidden");
  },

  // Validate the user info section
  ValidateUserInfo: function () {
    TECL_TenderUserInformationEditor.ClearValidationErrors();

    var firstName = $("#userFirstNameVal").val();
    var lastName = $("#userLastNameVal").val();
    var organisationId = $("#orgId").val();
    var positionId = $("#ddlPositions").val();
    var currentEmailAddress = $("#emailFromStart").val();
    var emailAddress = $("#userEmailAddressVal").val();
    var confirmEmailAddress = $("#userConfirmEmailAddressVal").val();

    var noErrors = true;

    if (!firstName) {
      $("#errUserDetailsFirstName").removeClass("hidden");
      noErrors = false;
    }

    if (!lastName) {
      $("#errUserDetailsLastName").removeClass("hidden");
      noErrors = false;
    }

    if (!organisationId) {
      $("#errUserDetailsOrganisation").removeClass("hidden");
      noErrors = false;
    }

    if (!positionId) {
      $("#errUserDetailsPosition").removeClass("hidden");
      noErrors = false;
    }

    if (!emailAddress || !TECL_Master.IsEmailAddress(emailAddress)) {

      $("#errUserDetailsEmailAddress").removeClass("hidden");
      noErrors = false;
    } else if ((currentEmailAddress !== emailAddress) && TECL_TenderUserInformation.ValidateEmailAddressAlreadyExists($("#userWebAccountIdVal").val(), emailAddress)) {

      $("#errUserDetailsUsedEmailAddress").removeClass("hidden");
      noErrors = false;
    } else if (emailAddress !== confirmEmailAddress) {

      $("#errUserDetailsConfirmEmailAddress").removeClass("hidden");
      noErrors = false;
    }

    return noErrors;
  },

  // Save the information
  SaveUserInformation: function () {
    if (TECL_Master.AddLock("TECL_TenderUserInformationEditor.SaveUserInformation")) {
      if (TECL_TenderUserInformationEditor.ValidateUserInfo()) {

        var userInfoData = TECL_TenderUserInformationEditor.SerialisedData();

        // Call Server to save the tender
        $.ajax({
          url: baseSiteUrl + "umbraco/Surface/Tender/SaveUserInformationChanges",
          type: "POST",
          dataType: "json",
          data: {
            userInfoData: userInfoData
          },
          error: function (exc) {
            TECL_Master.ClearLock("TECL_TenderUserInformationEditor.SaveUserInformation");
          },
          success: function (result) {
            TECL_Master.ClearLock("TECL_TenderUserInformationEditor.SaveUserInformation");

            if (result && result === true) {

              var $modal = $("#savedDetailsDialog");
              $modal.on("hidden.bs.modal", function () {
                window.location.reload();
              });
              $modal.modal("show");
            } else {
              TECL_Master.ShowErrorDialog("Failed to save the supplied information");
            }
          }
        });
      } else {
        TECL_Master.ClearLock("TECL_TenderUserInformationEditor.SaveUserInformation");
      }
    }
  },

  // Get the Serialised Data
  SerialisedData: function () {
    //get standard data
    var webAccountId = $("#userWebAccountIdVal").val();
    var firstName = $("#userFirstNameVal").val();
    var lastName = $("#userLastNameVal").val();
    var positionId = $("#ddlPositions").val();
    var organisationId = $("#organisationId").val();
    var organisationName = $("#schoolSearch").val();
    var emailAddress = $("#userEmailAddressVal").val();

    var userInfoData = {
      WebAccountId: webAccountId,
      FirstName: firstName,
      LastName: lastName,
      OrganisationId: organisationId,
      OrganisationName: organisationName,
      PositionId: positionId,
      EmailAddress: emailAddress
    }
    return userInfoData;
  }

};